<template>
  <el-dialog width="600px" title="售后订单编辑" v-model="isvisible">
    <el-form
      ref="saleFormRef"
      :model="saleForm"
      :rules="rules"
      label-width="120px"
    >
    <el-form-item label="销售金额" prop="saleamount">
            <el-input
              v-model="saleForm.saleamount"
              placeholder="请输入销售金额"
            />
          </el-form-item>
          <el-form-item label="成本金额" prop="costamount">
            <el-input
              v-model="saleForm.costamount"
              placeholder="请输入成本金额"
            />
          </el-form-item>
          <el-form-item label="实发数量" prop="realqty">
            <el-input-number
              v-model="saleForm.realqty"
              :min="0"
              :max="1"
              controls-position="right"
            />
          </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doAddSale" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { saveOrderSaleAmount } from "@/api/order/sale";

let timer;

const loading = ref(false);

const emit = defineEmits(["click"]); // 声明父触发事件

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const saleFormRef = ref();
const saleForm = ref({
  // saleid:"",
  orderid: "",
  customerid:"",
  saleamount:"",
  costamount: "",
  realqty: "1",
});
const saleMethod = (saleObj) => {
  saleForm.value = {
    // saleid: saleObj.saleid,
    orderid: saleObj.orderid,
    customerid: saleObj.customerid,
    saleamount: saleObj.saleamount,
    costamount: saleObj.costamount,
    // realqty: saleObj.realqty,
    realqty: 1,
  };
};

defineExpose({ changeVisible, saleMethod });

const doAddSale = () => {
  saleFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    //saleForm.value.orderid = saleInfo.value.orderid;
    saveOrderSaleAmount(saleForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog();
          emit("click");
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  saleFormRef.value.resetFields();
  clearTimeout(timer);
};

const validateDecimal = (rule, value, callback) => {
  if (typeof value === 'undefined') { callback();}
  //   const reg = /^d*(?:.d{0,2})?$/;
  console.log('value----',value)
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};

//表单验证规则
const rules = ref({
  saleamount: [
    {
      required: true,
      message: "请输入销售金额",
      trigger: "blur",
    },
    {
      required: true,
      validator: validateDecimal,
      trigger: "blur",
    }
  ],
  costamount: [
  {
      required: true,
      message: "请输入成本金额",
      trigger: "blur",
    },
    {
      required: true,
      validator: validateDecimal,
      trigger: "blur",
    }
  ],
  realqty: [
  {
      required: true,
      message: "请输入实发数量",
      trigger: "blur",
    },
    { type: 'number', message: '实发数量须是数字',trigger: "blur" },
  ],
});
</script>
  <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>